import { CalculatedUptProductSuggestion, PrepUptSource } from '@/src/types/apps/prepConfig'

export const CALCULATED_UPT_SUGGESTION_SUFFIX = ' (Calculated)'

export function showsCalculatedUptFabricKeyField(uptSource: PrepUptSource): boolean {
  return uptSource === 'CALCULATED'
}

export function formatCalculatedUptSuggestionLabel(productDescription: string): string {
  return `${productDescription}${CALCULATED_UPT_SUGGESTION_SUFFIX}`
}

export function persistCalculatedUptFabricKey(value: string | null | undefined): string {
  if (value == null) return ''
  const trimmed = value.trim()
  if (trimmed.endsWith('(Calculated)')) {
    return trimmed.slice(0, -'(Calculated)'.length).trimEnd()
  }

  return trimmed
}

export function filterCalculatedUptSuggestions(options: string[], inputValue: string): string[] {
  const query = persistCalculatedUptFabricKey(inputValue).toLowerCase()
  if (!query) return options

  return options.filter(option => option.toLowerCase().includes(query))
}

export function applyCalculatedUptSuggestionInput(
  value: string | null | undefined,
  reason?: string
): string | undefined {
  if (reason === 'reset') return undefined

  return persistCalculatedUptFabricKey(value)
}

function unwrapSuggestionPayload(data: unknown): unknown {
  let current: unknown = data
  if (current && typeof current === 'object' && 'data' in current) {
    current = (current as { data?: unknown }).data
  }
  if (current && typeof current === 'object' && 'data' in current && '_metadata' in current) {
    current = (current as { data?: unknown }).data
  }

  return current
}

export function mapCalculatedUptProductSuggestionResponse(data: unknown): string[] {
  const rows = unwrapSuggestionPayload(data)
  if (!Array.isArray(rows)) return []

  const seen = new Set<string>()
  const suggestions: string[] = []
  for (const row of rows) {
    const productDescription =
      row && typeof row === 'object' && typeof (row as CalculatedUptProductSuggestion).productDescription === 'string'
        ? (row as CalculatedUptProductSuggestion).productDescription
        : ''
    if (!productDescription || seen.has(productDescription)) continue
    seen.add(productDescription)
    suggestions.push(productDescription)
  }

  return suggestions
}
